<template>
  <v-app>
    <div class="view-container">
      <div class="view-main">
        <div class="pb-4 px-3 mt-4 mx-2 mx-sm-5">
          <v-layout
            style="height: 60px;background-color: var(--v-background2-base);"
            align-center
            class="ma-0 pa-0"
            d-flex
            justify-start
          >
            <div
              style="width:5px; height:100%;background-color:var(--v-secondary-base)"
              class="mr-4"
            />
            <div
              style="font-weight: bold;font-size: 18px;"
            >
              インポート
            </div>
          </v-layout>

          <v-card
            class=" mt-2 mt-sm-4"
            flat
            tile
          >
            <v-card-title class="text-subtitle-1">
              txtファイルからインポートして本文を登録します
            </v-card-title>
            <v-card-subtitle class="mt-1">
              インポートするファイルの形式を選択してください
            </v-card-subtitle>
            <v-card-text>
              <div class="smp">
                <ListIcon
                  style="color:var(--v-secondary-base) ;width:6px;height:7px"
                  class="mr-1 mb-1"
                />
                タイトルの場所
                <v-select
                  v-model="selectTitleType"
                  solo
                  dense
                  flat
                  label="タイトルの取得場所を選んでください"
                  :items="titleTypes"
                  background-color="background"
                  item-value="id"
                  item-text="label"
                  return-object
                />

                <ListIcon
                  style="color:var(--v-secondary-base) ;width:6px;height:7px"
                  class="mr-1 mb-1"
                />
                本文取得位置
                <v-select
                  v-model="selectTextType"
                  solo
                  dense
                  flat
                  label="本文の取得位置を選んでください"
                  :items="textTypes"
                  background-color="background"
                  item-value="id"
                  item-text="label"
                  return-object
                />
                <ListIcon
                  style="color:var(--v-secondary-base) ;width:6px;height:7px"
                  class="mr-1 mb-1"
                />
                ルビの自動変換
                <v-switch
                  v-model="autoRubiConvert"
                  class="ml-4"
                  label="自動変換する"
                />
              </div>

              <table class="pc">
                <tr>
                  <th>タイトルの場所</th>
                  <td>
                    <v-select
                      v-model="selectTitleType"
                      solo
                      dense
                      flat
                      label="タイトルの取得場所を選んでください"
                      :items="titleTypes"
                      background-color="background"
                      item-value="id"
                      item-text="label"
                      return-object
                      class="hide-details px-4"
                    />
                  </td>
                </tr>
                <tr>
                  <th>本文取得位置</th>
                  <td>
                    <v-select
                      v-model="selectTextType"
                      solo
                      dense
                      flat
                      label="本文の取得位置を選んでください"
                      :items="textTypes"
                      background-color="background"
                      item-value="id"
                      item-text="label"
                      return-object
                      class="hide-details px-4"
                    />
                  </td>
                </tr>
                <tr>
                  <th>ルビの自動変換</th>
                  <td>
                    <v-switch
                      v-model="autoRubiConvert"
                      class="ml-4"
                      label="自動変換する"
                    />
                  </td>
                </tr>
              </table>

              <div
                class="image-input mt-4 "
              >
                <div
                  :class="{'over': isDragOver}"
                  class="image-input__field"
                  @dragleave="onDrag('leave')"
                  @dragover.prevent="onDrag('over')"
                  @drop.stop="onDrop"
                >
                  <input
                    accept="text/plain"
                    multiple
                    title
                    type="file"
                    @change="inputFileList($event.target.files)"
                  >
                  <img
                    src="../assets/ic_file.png"
                    class="mr-2"
                    width="80"
                  >
                  <span
                    style="font-size:12px;"
                    class="mr-2"
                  >ドラッグ＆ドロップorクリックでテキストファイルを選択してください。(複数可)<br>※ブラウザによっては複数選択できません</span>
                </div>
                <div v-if="inputFiles">
                  {{ inputFiles.length }}ファイル選択中
                </div>
              </div>
              <v-card-actions>
                <v-spacer />
                <v-btn
                  color="secondary"
                  :disabled="!inputFiles"
                  tile
                  :loading="progress"
                  @click="save()"
                >
                  保存する
                </v-btn>
              </v-card-actions>
              <div>
                <ListIcon
                  style="color:var(--v-secondary-base) ;width:6px;height:7px"
                  class="mr-1"
                />
                インポート結果プレビュー<br>※１ファイルのみ表示
              </div>
              <div class="mt-2">
                タイトル：{{ previewTitle }}
              </div>
              <v-textarea
                rows="5"
                dense
                color="text"
                readonly
                filled
                class="mt-2"
                :value="previewText"
              />
            </v-card-text>
          </v-card>
        </div>
      </div>
    </div>
  </v-app>
</template>


<script>
import config from "@/const"
import ListIcon from "@/component/svg/ListIcon";
import Encoding from "encoding-japanese"
import axios from "axios";
import firebase from "firebase";
import rubiConverter from "@/component/rubiConverter";

export default {
  name: "TextImport",
  components: {
    ListIcon
  },
  data() {
    return {
      titleTypes: config.TEXT_IMPORT_TITLE_TYPE,
      selectTitleType: config.TEXT_IMPORT_TITLE_TYPE[0],
      textTypes: config.TEXT_IMPORT_TEXT_TYPE,
      selectTextType: config.TEXT_IMPORT_TEXT_TYPE[0],
      isDragOver: false,
      previewTitle: "",
      previewText: "",
      previewBaseFileName: "",
      previewBaseFileContent: "",
      inputFiles: null,
      inputFileContents: [],
      progress: false,
      autoRubiConvert: true,
      statusText: "",
    }
  },
  watch: {
    autoRubiConvert: {
      handler() {
        this.invalidatePreview()
      }
    },
    previewBaseFileContent: {
      handler() {
        this.invalidatePreview()
      }
    },
    previewBaseFileName: {
      handler() {
        this.invalidatePreview()
      }
    },
    selectTitleType: {
      handler() {
        this.invalidatePreview()
      }
    },
    selectTextType: {
      handler() {
        this.invalidatePreview()
      }
    },

  },
  methods: {
    onDrag(type) {
      this.isDragOver = type === "over";
    },
    onDrop(event) {
      this.isDragOver = false;
    },
    async save() {
      this.progress = true;
      this.statusText = `保存開始 files=${this.inputFiles.length}`
      await Promise.all(this.inputFileContents.map(async (file, index) => await this.saveFile(file, index)))
      this.progress = false;
      this.$router.back()

    },
    readFileAsync(file, index) {
      return new Promise((resolve, reject) => {
        let reader = new FileReader();

        reader.onload = () => {
          resolve(reader.result);
        };

        reader.onerror = (e) => {
          this.statusText = `saveFile onError ${e}`
          reject()
        };
        reader.readAsArrayBuffer(file);
      })
    },

    async saveFile(contents, index) {
      let file = this.inputFiles[index]

      let title = ""
      let text = ""
      if (this.selectTitleType == config.TEXT_IMPORT_TITLE_TYPE[0]) {
        title = file.name.split('.').slice(0, -1).join('.')
      }

      const user = firebase.auth().currentUser
      const token = await user.getIdToken(false)
      let contentBuffer = contents;

      let encodedText = this.encodeText(contentBuffer);
      let baseText = this.rubiConverterIfNeeded(encodedText)
      if (this.selectTitleType == config.TEXT_IMPORT_TITLE_TYPE[1]) {
        title = baseText.split('\n')[0]
      }
      if (this.selectTextType == config.TEXT_IMPORT_TEXT_TYPE[0]) {
        text = baseText;
      } else if (this.selectTextType == config.TEXT_IMPORT_TEXT_TYPE[1]) {
        const firstRowEndPos = baseText.indexOf('\n', 0);
        const outputString = baseText.substr(firstRowEndPos + 1);
        text = outputString;
      } else if (this.selectTextType == config.TEXT_IMPORT_TEXT_TYPE[2]) {
        let firstRowEndPos = baseText.indexOf('\n', 0);
        let outputString = baseText.substr(firstRowEndPos + 1);
        firstRowEndPos = outputString.indexOf('\n', 0);
        outputString = outputString.substr(firstRowEndPos + 1);
        text = outputString;
      }
      let saveData = {
        createdDate: Date.now(),
        novelId: config.HASH_IDS.decode(this.$route.params.novelid)[0],
        folderId: this.$route.params.folderid ? config.HASH_IDS.decode(this.$route.params.folderid)[0] : -1
      }

      saveData.modifiedTimestamp = Date.now()
      saveData.updateDate = Date.now()
      saveData.name = title
      saveData.content = text
      await axios.post(config.API_URL + "auth/page", saveData, {
        headers: {"X-Firebase-Auth": token, "fromWeb": true},
      })
    },
    async inputFileList(fileList) {
      // event.target.filesはファイルデータが格納されたリストです
      if (fileList.length == 0) {
        return
      }
      this.progress = true;
      this.inputFiles = [...fileList];
      this.inputFileContents = [];
      await Promise.all(this.inputFiles.map(async (file) => {
        this.inputFileContents.push(await this.readFileAsync(file))
      }))

      if (this.inputFileContents.length != 0) {
        this.previewBaseFileName = fileList[0].name.split('.').slice(0, -1).join('.')
        this.previewBaseFileContent = this.encodeText(this.inputFileContents[0]);
      }
      this.progress = false;
    },
    encodeText(text) {
      var codes = new Uint8Array(text);
      var encoding = Encoding.detect(codes);

      // Convert encoding to unicode
      var unicodeString = text
      if (encoding) {
        unicodeString = Encoding.convert(codes, {
          to: 'unicode',
          from: encoding,
          type: 'string'
        });
      }
      unicodeString = unicodeString.replaceAll("&amp;", "&")
          .replaceAll("&#x27", "'")
          .replaceAll("&#x60", '`')
          .replaceAll('&quot;', '"')
          .replaceAll('&lt;', '<')
          .replaceAll('&gt;:', '>')

      return unicodeString;
    },
    rubiConverterIfNeeded(text) {
      if (this.autoRubiConvert) {
        let novelId = config.HASH_IDS.decode(this.$route.params.novelid)[0]

        let currentNovel = this.$store.state.NovelListModule.NovelList.find(element => element.id == novelId)

        return rubiConverter.convert(-1,currentNovel.targetSite, text)
      } else {
        return text
      }
    },

    invalidatePreview() {
      if (this.selectTitleType == config.TEXT_IMPORT_TITLE_TYPE[0]) {
        this.previewTitle = this.previewBaseFileName
      }
      let baseText = this.rubiConverterIfNeeded(this.previewBaseFileContent)
      let text = ""
      if (this.selectTitleType == config.TEXT_IMPORT_TITLE_TYPE[1]) {
        this.previewTitle = baseText.split('\n')[0]
      }
      if (this.selectTextType == config.TEXT_IMPORT_TEXT_TYPE[0]) {
        text = baseText;
      } else if (this.selectTextType == config.TEXT_IMPORT_TEXT_TYPE[1]) {
        const firstRowEndPos = baseText.indexOf('\n', 0);
        const outputString = baseText.substr(firstRowEndPos + 1);
        text = outputString;
      } else if (this.selectTextType == config.TEXT_IMPORT_TEXT_TYPE[2]) {
        let firstRowEndPos = baseText.indexOf('\n', 0);
        let outputString = baseText.substr(firstRowEndPos + 1);
        firstRowEndPos = outputString.indexOf('\n', 0);
        outputString = outputString.substr(firstRowEndPos + 1);
        text = outputString;
      }
      this.previewText = text;
    }
  }
}
</script>

<style scoped>
table {
  width: 100%;
  border-collapse: collapse;
}

table tr {
  border-bottom: solid 2px var(--v-background2-base);
}

table tr:last-child {
  border-bottom: none;
}

table th {
  position: relative;
  text-align: left;
  width: 30%;
  background-color: var(--v-secondary-base);
  color: white;
  text-align: center;
  padding: 10px 0;
}

table th:after {
  display: block;
  content: "";
  width: 0px;
  height: 0px;
  position: absolute;
  top: calc(50% - 10px);
  right: -10px;
  border-left: 10px solid var(--v-secondary-base);
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
}

table td {
  text-align: left;
  width: 70%;
  text-align: center;
  background-color: var(--v-background-base);
  padding: 10px 0;
}

.image-input {
  height: 130px;
  width: 100%;
  background-color: var(--v-background-base);
}

.image-input__field {
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
}

.image-input__field.over {
  background-color: #666;
}

.image-input__field > input {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  opacity: 0;
  cursor: pointer;
}

.image-input__field > p {
  color: #aaa;
  text-align: center;
}
</style>